<template>
  <Modal
    no-cancel
    :tracking="{
      action: 'checkout',
      topicKey: 'high-frequency-game-max-play-slip-price',
    }"
    @cancel="dismiss"
    @confirm="dismiss"
  >
    <template #headline>
      {{ t('lottery.gameslipnavbar.modal.maxplayslipprice.headline') }}
    </template>

    <p>
      {{ t('lottery.gameslipnavbar.modal.maxplayslipprice.message', { limit: formattedLimit }) }}
    </p>

    <template #confirm>
      {{ t('lottery.gameslipnavbar.modal.maxplayslipprice.confirm') }}
    </template>
  </Modal>
</template>

<script lang="ts" setup>
import type { Money } from '#api/shared/@types/generated/backend/graphql-schema-types'

type Props = {
  limit: Money
}

type Emits = {
  (e: 'confirm'): void
}

const { limit } = defineProps<Props>()
const emit = defineEmits<Emits>()

const { t } = useI18n()

const dismiss = () => emit('confirm')

const formattedLimit = computed(() =>
  limit.value % 100 === 0 ? formatMoney(limit, { fractionDigits: 0 }) : formatMoney(limit),
)
</script>
